import React, {useCallback, useRef} from "react";
import { ViewerItemsColorContext, ViewerItemsColorContextProps } from "./viewer-items-color-context-props.ts";
import { ViewerItemsColorChangedModel } from "./models/viewer-items-color-changed-model.ts";
import FormattedObject from "@/models/interfaces/viewer/formatted-object.ts";
import SpaceTypo from "@/models/enums/space-typo.ts";
import ThermicTypo from "@/models/enums/thermic-typo.ts";

const ViewerItemsColorProvider: React.FC<React.PropsWithChildren> = ({children}) => {
    
    const colorsChangedListenerRef = useRef<Set<(event: ViewerItemsColorChangedModel) => void>>(new Set());
    
    const notifyColorChanged = useCallback((event: ViewerItemsColorChangedModel) => {
        colorsChangedListenerRef.current.forEach(listener => {
            listener(event);
        });
    }, []);
    
    const subscribeColorChanged = useCallback((listener: (event: ViewerItemsColorChangedModel) => void) => {
        colorsChangedListenerRef.current.add(listener);        
        return () => {
            colorsChangedListenerRef.current.delete(listener);
        }
    }, []);
    
    const changeColor = useCallback((items: FormattedObject[], color: string, shellTypo: SpaceTypo | undefined, thermalTypo: ThermicTypo | undefined) => notifyColorChanged({ items, color, shellTypo, thermalTypo }), [notifyColorChanged]);
    
    const contextProps: ViewerItemsColorContextProps = {
        subscribeColorChanged,
        changeColor
    }
    
    return (
        <ViewerItemsColorContext.Provider value={contextProps}>
            {children}
        </ViewerItemsColorContext.Provider>
    )
}

export default ViewerItemsColorProvider